import Repository from '@/repositories/repository'

const PrivacyPolicyRepository = {
  async getPrivacyPolicyData(queryParams: any = {}) {
    const params = {
      ...queryParams
    }

    return await Repository('privacy-policy', 'page', params)
  }
}

export default PrivacyPolicyRepository
